import { Entity } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetEntityQuery = (entityId?: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/entities?limit=10000`
	const { query, data, loading, error } = useQuery<void, EntitiesOutput>(url)
	const entity = entityId == null ? undefined : data?.entities?.find((s) => s.id === entityId)
	const invalidIdError = entityId !== "new" && !loading && entity == null ? "No Entity found" : undefined
	const entityError = error || invalidIdError
	return { query, data: entity, loading, error: entityError }
}
interface EntitiesOutput {
	entities: Entity[]
}
